import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageCleanupService {

    private readonly CLEANUP_VERSION = 'production_cleanup_v2';

    private readonly KEYS_TO_REMOVE = [
        'hotels',
        'companies',
        'holdings',
        'otas',
        'policies',
        'sources'
    ];

    constructor() {}

    cleanStorage(): void {
        const cleanupExecuted = localStorage.getItem(
            this.CLEANUP_VERSION
        );

        if (cleanupExecuted) {
            return;
        }

        this.KEYS_TO_REMOVE.forEach(key => {
            localStorage.removeItem(key);
        });

        localStorage.setItem(this.CLEANUP_VERSION, 'true');
    }
}